import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const items = [
  "Artificial Intelligence", "Cloud Native", "5G Networks", "Cybersecurity", "Blockchain",
  "Industrial IoT", "Automation", "DevOps", "Machine Learning", "Enterprise Integration",
  "EV Energy Management", "Digital Transformation",
];

export const TechMarquee = () => (
  <div className="relative z-10 border-y border-white/10 bg-ink-950 py-6" data-testid="tech-marquee">
    <Marquee speed={40} gradient gradientColor="#050506" gradientWidth={120}>
      {items.map((t, i) => (
        <div key={i} className="flex items-center gap-6 px-6">
          <span className="font-display text-lg font-medium uppercase tracking-[0.15em] text-zinc-500">
            {t}
          </span>
          <Sparkle className="h-4 w-4 text-brand/60" />
        </div>
      ))}
    </Marquee>
  </div>
);
